import type { RouteLocation } from 'vue-router'
import { useAuthStore } from '@/stores/AuthStore'
import { useEmployeeStore } from '@/stores/EmployeeStore'
import { areas } from '@/router/areas'

export async function myAreaMiddleware(to: RouteLocation, from: RouteLocation) {
  const authStore = useAuthStore()

  const leavingMyArea =
    from.meta.area === areas.MY_AREA && to.meta.area !== areas.MY_AREA

  if (leavingMyArea && authStore.isTeamDevice) {
    const employeeStore = useEmployeeStore()
    if (
      employeeStore.employee?.id !== employeeStore.teamleader?.id &&
      employeeStore.teamleader
    ) {
      employeeStore.setActiveEmployee(employeeStore.teamleader)
    }
    if (!employeeStore.teamleader) {
      employeeStore.setTeamleader(null)
    }
  }

  if (leavingMyArea && !authStore.isPersonalDevice) {
    await authStore.logoutUser()
  }

  return true
}
